import { render, staticRenderFns } from "./PointHistory.vue?vue&type=template&id=09b800d3&scoped=true"
import script from "./PointHistory.vue?vue&type=script&lang=js"
export * from "./PointHistory.vue?vue&type=script&lang=js"
import style0 from "./PointHistory.vue?vue&type=style&index=0&id=09b800d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b800d3",
  null
  
)

export default component.exports